document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[data-scroll-to-target]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault()

      const target = document.querySelector(link.getAttribute('href'))
      if (!target) return

      target.scrollIntoView({ behavior: 'smooth' })
    })
  })
})
